import { render, staticRenderFns } from "./Writte.vue?vue&type=template&id=bb76c0a0&"
import script from "./Writte.vue?vue&type=script&lang=js&"
export * from "./Writte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports